/* eslint-disable no-undef */
import React from "react";
import { Button} from "antd";
import { useNavigate } from "react-router-dom";

const ResetPasswordConfirmation = () => {
    const navigate = useNavigate();

    const handleLogin = () => {
        navigate("/");
    };

    return (


        <div className="vh-100 d-flex justify-content-center align-items-center flex-column px-3 login-bg login-form">

            <div className="container">
                <div className="row mb-4">
                    <div className="col-12">
                        <figure className="text-center mx-auto mb-0">
                            <img src="/logo-dark.png" className="img-fluid logo" alt="Company Logo" />
                        </figure>
                    </div>
                </div>
            </div>

            <div className="mx-auto card mt-2">
                <div className="card-body">

                    <div className="row">
                        <div className="col-12 text-center padding pb-0">
                            <p className="card-title mb-3 w-100">Password Reset Successfully!</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="border-0 d-flex justify-content-center p-3">
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className="btn-primary d-block submit-button mb-3"
                                    onClick={handleLogin}
                                >
                                    BACK TO LOGIN
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    );
};

export default ResetPasswordConfirmation;
